module.exports = __webpack_public_path__ + "img/Componente 46 – 1.032feaa7.svg";